const NavCancel = () => (
   <div className="svg cancel" area-label="icon" >
      <svg
         id="nav-cancel"
         width="21"
         height="21"
         viewBox="0 0 200 200"
         strokeWidth="12"
         strokeLinecap="round"
      >
         <line
            stroke="currentColor"
            y2="152.4"
            x2="155"
            y1="47.6"
            x1="45"
         />
         <line
            stroke="currentColor"
            y2="47.6"
            x2="155"
            y1="152.4"
            x1="45"
         />
      </svg>
   </div>
);

export default NavCancel;
